// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"tableStyles_tableWrapper__2kvr4","table":"tableStyles_table__2C00M","th":"tableStyles_th__3D40K","td":"tableStyles_td__2bk42"};